import { render, staticRenderFns } from "./SelectBoxV2.vue?vue&type=template&id=7d8eb4de&scoped=true"
import script from "./SelectBoxV2.vue?vue&type=script&lang=ts"
export * from "./SelectBoxV2.vue?vue&type=script&lang=ts"
import style0 from "./SelectBoxV2.vue?vue&type=style&index=0&id=7d8eb4de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8eb4de",
  null
  
)

export default component.exports